import { render } from "./HsCard.vue?vue&type=template&id=123bae97&scoped=true"
import script from "./HsCard.vue?vue&type=script&lang=js"
export * from "./HsCard.vue?vue&type=script&lang=js"

import "./HsCard.vue?vue&type=style&index=0&id=123bae97&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123bae97"]])

export default __exports__